<div class="d-flex header">
    <div class="logo cup">
        <nb-icon class="full-height" icon="logo" routerLink="/page"></nb-icon>
    </div>
    <div class="d-flex header-info">
        <nb-icon (click)="openSideNav()" class="full-height burger cup" [icon]="!(sideNavService.status | async) ? 'burger' : 'burgerClose'" ></nb-icon>
        <div (clickOutside)="showNotis=false" class="header-info__message  pos-rel">
            <nb-actions size="small">
                <nb-action
                    (click)="showNotis=!showNotis"
                    [badgeDot]="newNotis"
                    [badgeText]="countNewMsg"
                    badgePosition="bottom"
                    badgeStatus="danger"
                    icon="bell"></nb-action>
            </nb-actions>
            <app-notifications (clear)="clear()" *ngIf="showNotis" [list]="list"></app-notifications>
        </div>
        <div class="header-info__tariffs">
            <a class="header-text-item" routerLink="/tariff">Тарифы</a>
        </div>

        <div class="header-info__users d-flex align-items-center" routerLink="/page/settings">
            <div class="header-info__users_setting">
                <a *ngIf="user$ | async as user" class="header-text-item"
                >{{getName(user)}}</a>
            </div>

            <div class="header-info__users_avatar">
                <nb-icon class="full-height avatar" icon="userAvatar"></nb-icon>
            </div>

        </div>

        <div class="header-info__logout">
            <nb-icon (click)="logout()" class="cup" icon="logout"></nb-icon>
        </div>


    </div>
</div>
